import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { MapPin } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryLotLocationDisplay,
    getItemSummarySellerName,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';

export type SellerNameComponentExperimentProps = ItemSummary & { position: number };

//Experiment SEAR-769: New similar items CTA experiment
export const SellerNameComponentExperiment = createInfo<SellerNameComponentExperimentProps>({
    useText: ({ itemId }) => {
        const sellerName = useAppSelector((state) => getItemSummarySellerName(state, itemId));
        const {
            city: lotLocationCity,
            countryCode: lotLocationCountryCode,
            region: lotLocationRegion,
        } = useAppSelector((state) => getItemSummaryLotLocationDisplay(state, itemId));

        const sellerLocation =
            lotLocationCity === lotLocationRegion
                ? [lotLocationCity, lotLocationCountryCode].filter(Boolean).join(', ')
                : [lotLocationCity, lotLocationRegion].filter(Boolean).join(', ');

        return (
            <div className="mb-xs mt-auto flex flex-col gap-y-2xs overflow-hidden px-xs smMin:flex-row smMin:items-baseline smMin:gap-x-xs smMin:px-sm">
                <BodySecondary className="order-2 min-w-0 flex-1 truncate text-xs text-text-secondary smMin:order-1 smMin:text-sm">
                    {sellerName}
                </BodySecondary>
                {sellerLocation && (
                    <BodySecondary className="order-1 flex min-w-0 items-baseline gap-x-2xs overflow-hidden text-xs text-text-secondary smMin:order-2 smMin:shrink-0 smMin:overflow-visible smMin:whitespace-normal smMin:text-sm">
                        <span className="inline-flex shrink-0 translate-y-[2px] leading-none">
                            <MapPin size="xs" />
                        </span>
                        <span className="min-w-0 truncate">{sellerLocation}</span>
                    </BodySecondary>
                )}
            </div>
        );
    },
});
